import React, { Component } from 'react'
import { Checkbox, Icon, Popconfirm, Button } from 'antd'
import { collections } from '@services/api'

export default class Details extends Component<any, any> {
    constructor(props) {
        super(props)

        this.state = {
            open: false,
            isPrevent: props.usageMode.includes(1),
            isRoutine: props.usageMode.includes(2),
            isEmergency: props.usageMode.includes(3)
        }
    }

    toggleVisibility = () => {
        this.setState(prevState => ({ open: !prevState.open }))
    }

    handleSubmit = async () => {
        const { isPrevent, isRoutine, isEmergency } = this.state
        const { udpateCollections, collectionId } = this.props
        await collections.updateUsageMode({ isPrevent, isRoutine, isEmergency, collectionId })
        udpateCollections()
    }

    render() {
        const { open, isPrevent, isRoutine, isEmergency } = this.state
        const { title, usageMode } = this.props
        return (
            <div style={{ cursor: 'pointer' }}>
                <div style={{ textDecoration: 'underline' }} onClick={() => this.toggleVisibility()}>
                    <Icon type={open ? 'down' : 'left'} style={{ fontSize: '0.8rem', marginLeft: '0.5rem' }} />
                    <span>{title}</span>
                </div>
                <div
                    style={{
                        display: `${this.state.open ? 'flex' : 'none'}`,
                        paddingRight: '1.5rem',
                        flexDirection: 'column'
                    }}
                >
                    <div style={{ display: 'flex', flexDirection: 'row' }}>
                        מניעה -
                        <Checkbox checked={isPrevent} onChange={e => this.setState({ isPrevent: e.target.checked })} />
                    </div>
                    <div style={{ display: 'flex', flexDirection: 'row' }}>
                        שיגרה -
                        <Checkbox checked={isRoutine} onChange={e => this.setState({ isRoutine: e.target.checked })} />
                    </div>
                    <div style={{ display: 'flex', flexDirection: 'row' }}>
                        חירום -
                        <Checkbox
                            checked={isEmergency}
                            onChange={e => this.setState({ isEmergency: e.target.checked })}
                        />
                    </div>
                    <Popconfirm
                        disabled={
                            usageMode.includes(1) == isPrevent &&
                            usageMode.includes(2) == isRoutine &&
                            usageMode.includes(3) == isEmergency
                        }
                        onConfirm={() => this.handleSubmit()}
                        okText="אישור"
                        cancelText="ביטול"
                        title={'האם לעדכן אופן שימוש?'}
                    >
                        <Button
                            style={{ width: '55%', marginTop: '0.5rem' }}
                            disabled={
                                usageMode.includes(1) == isPrevent &&
                                usageMode.includes(2) == isRoutine &&
                                usageMode.includes(3) == isEmergency
                            }
                            type="primary"
                        >
                            <Icon type="check" />
                        </Button>
                    </Popconfirm>
                </div>
            </div>
        )
    }
}
